import React from 'react';

import Button from 'settings/page-elements/Button';

class ClientsListDownload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="clients hidden">
        <div className="download-status-message">
          {this.props.isFetching && (
            <div>
              <span>Fetching client list CSV....</span>
            </div>
          )}
          {this.props.errorMessage && (
            <div>
              <span className="alert warning">Sorry could not fetch client list CSV. {this.props.errorMessage}</span>
            </div>
          )}
        </div>
        <div className="transactions">
          <div className="list-view row">
            <div className="col-lg-12 log">
              Client List
              <Button
                buttonName="Download"
                onClickButton={() => this.props.clientsListCSV(this.props.salonId)}
                className="btn-sm pull-right"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ClientsListDownload;
